// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"w3-z"};